import React from "react";
import { List, ListItem, Typography, Box, Stack } from "@mui/material";
import moment from "moment";
import ShopifyLogo from "../Pictures/ShopifyLogo";

interface ConnectionsListProps {
  connections: { shop_domain: string; created_at: string; updated_at: string }[];
}

const ConnectionsList: React.FC<ConnectionsListProps> = ({ connections }) => {
  return (
    <List>
      {connections.map((connection, index) => (
        <ListItem key={index}>
          <Box sx={{ width: "100%", flexDirection: "row", display: "flex" }}>
            <ShopifyLogo size={36}/>
            {/* Display Store Domain Horizontally */}
            <Box>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="subtitle1" fontWeight="bold">
                  Store Domain:
                </Typography>
                <Typography variant="body1">{connection.shop_domain}</Typography>
              </Stack>

              {/* Display Created and Updated Dates */}
              <Typography variant="body2" color="textSecondary">

                Created: {moment.unix(parseInt(connection.created_at, 10) / 1000).format("MMMM D, YYYY h:mm A")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Updated: {moment.unix(parseInt(connection.updated_at, 10) / 1000).format("MMMM D, YYYY h:mm A")}
              </Typography>
            </Box>
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export default ConnectionsList;
